// To keep consistency with pipes throwing this: https://github.com/angular/angular/blob/4.1.3/packages/common/src/pipes/invalid_pipe_argument_error.ts
export function invalidPipeArgumentError(type: any, value: Object) {
    return Error(`InvalidPipeArgument: '${value}' for pipe '${type}'`);
  }